import "react-native-get-random-values";
import "react-native-reanimated";
import "@/lib/nativewind-setup"; // Configure Animated components for NativeWind
import { LogBox } from "react-native";
import "./global.css";
import "expo-router/entry";
LogBox.ignoreLogs(["Expo AV has been deprecated", "Disconnected from Metro"]);
